import React from 'react';
import { Select } from 'antd';
import ArrowDownIcon from './icons/arrow-down.icon';
import './style.scss'

export default function CustomSelect(props) {
	return (
		<>
			<Select suffixIcon={<ArrowDownIcon />} {...props} placeholder={props.placeholder || 'Selecciona'} />
		</>
	);
}

CustomSelect.Option = Select.Option;